interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const BodyLarge = ({ children, className = '' }: TypographyProps) => {
    return (
        <p className={`font-outfit text-[32px] lg:text-[56px] font-bold leading-[36px] lg:leading-[60px] ${className}`}>
            {children}
        </p>
    );
};